<template>
    <div class="page-wrapper">
        <div class="permit-panel">
            <div class="section">
                <div class="title">{{ $t("zhiji.moduleConf.perList") }}</div>
                <el-button v-if="isAdmin" @click="addFirstLevel" class="add-button">{{ $t("zhiji.moduleConf.newFirstLevel") }}</el-button>
                <el-tree
                    class="tree-box"
                    ref="tree"
                    node-key="id"
                    default-expand-all
                    show-checkbox
                    :default-checked-keys="allCheckedKeys"
                    :data="defaultData"
                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span v-show="isAdmin">
                            <i class="el-icon-circle-plus-outline icon icon-font" v-if="data.level < 4" @click.stop="() => append(data)"></i>
                            <i class="el-icon-view icon-font" @click.stop="() => view(data)"></i>
                            <i class="el-icon-delete-solid icon-font" v-if="data.level != 0" @click.stop="() => removeGlobal(node, data)"></i>
                        </span>
                    </span>
                </el-tree>
                <el-switch v-model="isAdmin" class="edit-switch" :active-text="$t('zhiji.personnel.roleManage.editPermission')"></el-switch>
            </div>
            <div class="section oprations">
                <el-button class="operator" @click="addToModule('robot')">{{ $t("zhiji.moduleConf.atoRobot") }}</el-button>
                <el-button class="operator" @click="addToModule('ticket')">{{ $t("zhiji.moduleConf.atoTicket") }}</el-button>
                <!-- el-button class="operator" @click="addToModule('im')">{{ $t("zhiji.moduleConf.atoIm") }}</el-button -->
                <el-button class="operator" @click="addToModule('titan')">{{ $t("zhiji.moduleConf.atoTitan") }}</el-button>
                <el-button class="operator" @click="addToModule('uo')">{{ $t("zhiji.moduleConf.atoUo") }}</el-button>
            </div>
            <div class="section target-modules">
                <div class="module" v-for="mod in modules" :key="mod.key">
                    <div class="title">{{ mod.title }}</div>
                    <el-tree class="tree-box" node-key="id" default-expand-all :data="moduleData[mod.data]">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>
                            <span>
                                <i class="el-icon-error icon-font" @click.stop="() => remove(mod.key, data)"></i>
                            </span>
                        </span>
                    </el-tree>
                </div>
            </div>
        </div>
        <AddModal :data="addData" v-if="isShowAddModel" />
    </div>
</template>

<script>
import AddModal from "./AddModal";
import { filterTrees, recursionTrans } from "@/views/zhiji/js/common/util.js";
import { queryModules, setModule } from "./service.js";

export default {
    components: {
        AddModal
    },
    data() {
        return {
            isShowAddModel: false,
            addData: null,
            isAdmin: false,
            allCheckedKeys: [],
            allTreeData: [],
            robot: [],
            ticket: [],
            im: [],
            titan: [],
            uo: []
        };
    },
    computed: {
        modules() {
            return [
                {
                    title: this.$t("zhiji.menu.robot"),
                    key: "robot",
                    data: "robotData"
                },
                {
                    title: this.$t("zhiji.business.tiket"),
                    key: "ticket",
                    data: "ticketData"
                },
                // {
                //     title: this.$t("zhiji.business.im"),
                //     key: "im",
                //     data: "imData"
                // }
                {
                    title: "titan",
                    key: "titan",
                    data: "titanData"
                },
                {
                    title: "uo",
                    key: "uo",
                    data: "uoData"
                }
            ];
        },
        defaultData() {
            const allDisableds = Array.from(new Set([...this.robot, ...this.ticket, ...this.im, ...this.titan, ...this.uo]));
            return recursionTrans(
                this.allTreeData,
                treeData => {
                    return Object.assign({}, treeData, { disabled: allDisableds.includes(treeData.id) });
                },
                "children"
            );
        },
        moduleData() {
            return {
                robotData: this.robotData,
                ticketData: this.ticketData,
                imData: this.imData,
                titanData: this.titanData,
                uoData: this.uoData
            };
        },
        robotData() {
            return this.filterModule("robot");
        },
        ticketData() {
            return this.filterModule("ticket");
        },
        imData() {
            return this.filterModule("im");
        },
        titanData() {
            return this.filterModule("titan");
        },
        uoData() {
            return this.filterModule("uo");
        }
    },
    methods: {
        filterModule(moduleName){
            return filterTrees(this.allTreeData, treeData => {
                return this[moduleName].indexOf(treeData.id) != -1;
            });
        },
        addToModule(moduleName) {
            const checkedKeys = [].concat(this.$refs.tree.getCheckedKeys(), this.$refs.tree.getHalfCheckedKeys());
            const mergedKeys = Array.from(new Set([...this[moduleName], ...checkedKeys]));
            this[moduleName].splice(0, this[moduleName].length, ...mergedKeys);
            this.$refs.tree.setCheckedKeys([]);
            this.setModule(moduleName);
        },
        remove(moduleName, data) {
            this.$alert(this.$t("zhiji.moduleConf.deleteTips"), this.$t("zhiji.common.tips"), {
                confirmButtonText: this.$t("zhiji.common.confirm"),
                callback: action => {
                    action == "confirm" && this.deleteModulePermit(moduleName, data);
                }
            });
        },
        deleteModulePermit(moduleName, data) {
            const deleteKeys = [data.id];
            recursionTrans(
                data.children || [],
                treeData => {
                    deleteKeys.push(treeData.id);
                    return treeData;
                },
                "children"
            );
            this[moduleName] = this[moduleName].filter(key => !deleteKeys.includes(key));
            this.setModule(moduleName);
        },
        async queryModules() {
            const modules = await queryModules();
            this.robot.splice(0, this.robot.length, ...modules.robot);
            this.ticket.splice(0, this.ticket.length, ...modules.ticket);
            this.im.splice(0, this.im.length, ...modules.im);
            this.titan.splice(0, this.titan.length, ...modules.titan);
            this.uo.splice(0, this.uo.length, ...modules.uo);
        },
        async setModule(moduleName) {
            await setModule(moduleName, this[moduleName]);
            this.queryModules();
        },
        queryAllPermits() {
            this.zhiji.requestByServiceName("getPermitList", {}).then(data => {
                this.allTreeData = data;
            });
        },
        addFirstLevel() {
            this.append({
                id: "0",
                level: 0,
                parentId: "0"
            });
        },
        append(data) {
            this.addData = {
                node: data,
                type: "append",
                cancel: () => {
                    this.isShowAddModel = false;
                },
                confirm: ({ id, name }) => {
                    this.zhiji
                        .requestByServiceName("addPermit", {
                            id,
                            name,
                            parentId: data.id
                        })
                        .then(({ added }) => {
                            if (added) {
                                this.queryAllPermits();
                            }
                        });
                    this.isShowAddModel = false;
                }
            };
            this.isShowAddModel = true;
        },
        view(data) {
            this.addData = {
                node: { ...data, level: data.level - 1 },
                type: "view",
                cancel: () => {
                    this.isShowAddModel = false;
                },
                confirm: () => {
                    this.isShowAddModel = false;
                }
            };
            this.isShowAddModel = true;
        },
        removeGlobal(node, data) {
            this.$confirm(
                `${this.$t("zhiji.personnel.roleManage.isDelete")} "${data.label}" ${this.$t("zhiji.personnel.roleManage.thisPermission")}?`,
                this.$t("zhiji.common.tips"),
                {
                    confirmButtonText: this.$t("zhiji.common.confirm"),
                    cancelButtonText: this.$t("zhiji.common.cancel"),
                    type: "warning"
                }
            )
                .then(() => {
                    this.zhiji
                        .requestByServiceName("deletePermit", {
                            id: data.id
                        })
                        .then(({ deleted }) => {
                            if (deleted) {
                                this.queryAllPermits();
                            }
                        });
                })
                .catch(() => {});
        }
    },
    created() {
        this.queryAllPermits();
        this.queryModules();
    }
};
</script>

<style scoped>
.page-wrapper {
    padding: 20px 10px;
}
.add-button {
    margin: 3px 0 8px;
}
.permit-panel {
    display: flex;
}
.section {
    padding: 10px;
}
.title {
    font-size: 14px;
    margin-bottom: 5px;
}
.edit-switch {
    margin-top: 8px;
}
.tree-box {
    height: 600px;
    min-width: 300px;
    border: 1px solid #c1d3e2;
    border-radius: 4px;
    overflow: auto;
    background: #fff;
}
.target-modules {
    display: flex;
}
.module {
    margin-right: 10px;
}
.oprations {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.operator {
    margin: 5px 0;
}
.custom-tree-node {
    font-size: 14px;
}
.icon-font {
    margin-left: 8px;
    display: none;
}
.page-wrapper >>> .el-tree-node__content:hover .icon-font {
    display: inline;
}
.page-wrapper >>> .is-disabled .el-checkbox__inner {
    background: rgb(214, 211, 211);
}
</style>
